<template>
    <el-container direction="vertical" class="spreadsheet">
        <el-row type="flex" align="middle" class="spreadsheet-header" justify="space-between">
            <el-col :span="15">
                <div class="spreadsheet-header-title">
                    {{ title }}
                </div>
                <div class="spreadsheet-header-filter-info">
                    <span class="spreadsheet-header-filter-info_black">
                        Поиск по:
                    </span>
                    <span class="spreadsheet-header-filter-info_gray">
                        {{ filterTitle }}
                    </span>
                </div>
            </el-col>
            <el-col :span="2">
                <el-popover
                    popper-class="grid-search-dialog"
                    placement="top"
                    width="293"
                    trigger="click"
                    v-model="isFilterFormVisible"
                >
                    <el-button slot="reference" class="spreadsheet-header-button" type="warning">
                        поиск
                    </el-button>
                    <el-form label-position="top" @keyup.enter.native="filterApplied">
                        <el-form-item :label="fieldsNames.created_at" :label-width="formLabelWidth" v-if="isColumnVisible('created_at')">
                            <el-date-picker
                                v-model="filterModel.created_at"
                                type="daterange"
                                range-separator="по"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.status_id" :label-width="formLabelWidth" v-if="isColumnVisible('status_id')">
                            <el-select
                                v-model="filterModel.status_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                multiple
                                collapse-tags
                                clearable
                                size="mini"
                            >
                                <el-option v-for="item in messageStatuses" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.phone" :label-width="formLabelWidth" v-if="isColumnVisible('phone')">
                            <el-input v-model="filterModel.phone" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.message" :label-width="formLabelWidth" v-if="isColumnVisible('message')">
                            <el-input v-model="filterModel.message" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                    </el-form>
                    <div class="popover-footer">
                        <el-button @click="hideFilterForm">
                            Отменить
                        </el-button>
                        <el-button type="warning" @click="filterApplied">
                            Применить
                        </el-button>
                    </div>
                </el-popover>
            </el-col>
            <el-col :span="7">
                <span class="spreadsheet-header-total">
                    Всего записей: {{ pagesInfo.total }}
                </span>
            </el-col>
        </el-row>
        <el-row type="flex" align="top" class="spreadsheet-table" v-loading="loading">
            <el-col :span="24">
                <ag-grid-vue
                    class="ag-theme-balham spreadsheet-table-grid"
                    :grid-options="gridOptions"
                    :column-defs="columnDefs"
                />
            </el-col>
        </el-row>
        <el-row type="flex" align="bottom" class="spreadsheet-bar">
            <el-col :span="6">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="pagesInfo.total"
                    :page-size="pageModel.pageSize"
                    :current-page="pageModel.currentPage"
                    :small="true"
                    @current-change="getCurrentPage"
                />
            </el-col>
            <el-col :span="10">
                <div class="spreadsheet-bar-pages">
                    <span class="spreadsheet-bar-pages-title">
                        Выводить по:
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize20}"
                        @click="setPageSize(20)"
                    >
                        20
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize50}"
                        @click="setPageSize(50)"
                    >
                        50
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize100}"
                        @click="setPageSize(100)"
                    >
                        100
                    </span>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="spreadsheet-bar-total">
                    <span>
                        Строк выведено: {{ totalRows }} Из них выделено: {{ selectedRowsCount }}
                    </span>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import TableHeaderSettings from '@/components/TableHeaderSettings';
import capitalize from 'lodash/capitalize';
import '@/assets/styles/list.scss';
import localReferences from '@/helpers/localReferences';
import moment from 'moment';
import { pickerOptions } from '@/common/pickerOptions';

export default {
    name: 'SmsLog',
    data() {
        return {
            title: 'Лог СМС сообщений',
            isFilterFormVisible: false,
            filterModel: {
                created_at: [],
                phone: null,
                message: null,
                status_id: []
            },
            fieldsNames: {
                created_at: 'дата',
                phone: 'телефон',
                message: 'сообщение',
                status_id: 'статус',
                status_text: 'расширенный статус'
            },
            pageModel: {
                currentPage: 1,
                pageSize: 20
            },
            formLabelWidth: '120px',
            totalRows: 0,
            selectedRowsCount: 0,
            loading: true,
            gridOptions: {
                rowSelection: 'multiple',
                suppressDragLeaveHidesColumns: false,
                suppressPaginationPanel: true,
                suppressLoadingOverlay: true,
                rowDeselection: true,
                enableCellTextSelection: true,
                headerHeight: 50,
                rowHeight: 40,
                domLayout: 'autoHeight',
                onRowDataChanged: this.onRowDataChanged.bind(this),
                onRowSelected: this.onRowSelected.bind(this),
                onColumnResized: this.onColumnResized.bind(this),
                onDisplayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
                onSortChanged: this.onSortChanged.bind(this),
                defaultColDef: {
                    sortable: true,
                    filter: false,
                    resizable: true,
                    autoHeight: false,
                    cellClass: 'column-text',
                    comparator: () => {
                        return 0;
                    }
                }
            },
            columnDefs: [],
            pickerOptions
        };
    },
    components: {
        AgGridVue
    },
    computed: {
        system() {
            return this.$store.state.logs.sms;
        },
        pagesInfo() {
            return this.$store.state.logs.pages;
        },
        setting() {
            return this.$store.state.preferences.setting;
        },
        messageStatuses() {
            return this.$store.state.references.messageStatuses;
        },
        isSetPageSize20() {
            return this.pageModel.pageSize === 20;
        },
        isSetPageSize50() {
            return this.pageModel.pageSize === 50;
        },
        isSetPageSize100() {
            return this.pageModel.pageSize === 100;
        },
        filterTitle() {
            let result = '';
            for (const field in this.filterModel) {
                if (Object.prototype.hasOwnProperty.call(this.filterModel, field) && this.filterModel[field]) {
                    const getNamesFrom = (obj) => {
                        if (Object.keys(obj).length !== 0) {
                            return (this.fieldsNames[field] + ': ' + this.filterModel[field].map(id => obj.find(item => item.id === id).name).join(' | ') + '; ');
                        } else {
                            return '';
                        }
                    };
                    if (['string', 'object'].includes(typeof this.filterModel[field]) && this.filterModel[field].length) {
                        switch (field) {
                            case 'created_at':
                                result += `${this.fieldsNames[field]}: ${this.filterModel[field][0]} по ${this.filterModel[field][1]}; `;
                                break;
                            case 'status_id':
                                result += getNamesFrom(this.messageStatuses);
                                break;
                            default:
                                result += (this.fieldsNames[field] + ': ' + this.filterModel[field] + '; ');
                        }
                    }
                }
            }
            return result;
        }
    },
    created() {
        this.columnDefs = [
            {
                headerName: this.capitalize(this.fieldsNames.created_at),
                field: 'created_at',
                cellRenderer: ({ data }) => data.created_at
            },
            {
                headerName: this.capitalize(this.fieldsNames.phone),
                field: 'phone'
            },
            {
                headerName: this.capitalize(this.fieldsNames.message),
                field: 'message'
            },
            {
                headerName: this.capitalize(this.fieldsNames.status_id),
                field: 'status_id',
                cellRenderer: ({ data }) => data.status_id ? data.status.name : ''
            },
            {
                headerName: this.capitalize(this.fieldsNames.status_text),
                field: 'status_text'
            },
            {
                headerName: '',
                field: '',
                headerComponentFramework: TableHeaderSettings,
                width: 40,
                cellClass: null
            }
        ];
    },
    mounted() {
        this.$store.dispatch('preferences/getPreferences').then(
            () => {
                this.setSettings();
            }).catch(() => {
            this.getDataFromServer();
        });
    },
    methods: {
        setSettings() {
            const settings = this.setting.smsLog;
            if (settings) {
                this.gridOptions.columnApi.setColumnState(settings.table);
                this.gridOptions.api.setSortModel(settings.sort);
                this.filterModel = JSON.parse(JSON.stringify(settings.filter));
                this.pageModel = JSON.parse(JSON.stringify(settings.page));
            } else {
                this.gridOptions.api.setSortModel({});
            }
        },
        hideFilterForm() {
            this.isFilterFormVisible = false;
        },
        getDataFromServer() {
            const requestParams = {
                size: this.pageModel.pageSize,
                page: this.pageModel.currentPage,
                sort: this.gridOptions.api.getSortModel(),
                filter: this.filterModel
            };
            this.loading = true;
            this.$store.dispatch('logs/getSms', requestParams).then(
                response => {
                    this.gridOptions.api.setRowData(this.system);
                    this.pageModel.pageSize = +response.data.meta.per_page;
                    this.pageModel.currentPage = response.data.meta.current_page;
                    this.saveSetting();
                }).catch(
                error => {
                    console.log(error);
                }).finally(() => {
                this.loading = false;
            });
        },
        setPageSize(size) {
            this.pageModel.pageSize = size;
            this.getDataFromServer();
        },
        getCurrentPage(page) {
            this.pageModel.currentPage = page;
            this.getDataFromServer();
        },
        filterApplied() {
            this.isFilterFormVisible = false;
            this.pageModel.currentPage = 1;
            this.getDataFromServer();
        },
        onRowDataChanged() {
            this.totalRows = this.gridOptions.api.getDisplayedRowCount();
        },
        onRowSelected() {
            this.selectedRowsCount = this.gridOptions.api.getSelectedRows().length;
        },
        isColumnVisible(colId) {
            return this.isFilterFormVisible && this.gridOptions.columnApi ? this.gridOptions.columnApi.getColumn(colId).visible : false;
        },
        onDisplayedColumnsChanged() {
            this.saveSetting();
        },
        onColumnResized(data) {
            if (data.finished && data.source === 'uiColumnDragged') {
                this.saveSetting();
            }
        },
        onSortChanged() {
            this.getDataFromServer();
        },
        async saveSetting() {
            const data = {
                'smsLog': {
                    'table': this.gridOptions.columnApi.getColumnState(),
                    'sort': this.gridOptions.api.getSortModel(),
                    'filter': this.filterModel,
                    'page': this.pageModel
                }
            };
            await this.$store.dispatch('preferences/setPreferences', data);
        },
        capitalize
    }
};
</script>
